import React from 'react';
import {observer} from 'mobx-react'
import {SpinnerOverlay} from './SpinnerOverlay'
import { IFormBean } from '../datatypes';

interface Props{
    formBean:IFormBean
}

export default observer( class ObservableSpinner extends React.Component<Props, {}> {
  render() {
    const isLoading = this.props.formBean.isLoading;

    return !isLoading ? null : <SpinnerOverlay loadingText={this.props.formBean.loadingText || ''} />
  }
})